import React, { FC } from 'react'
import { Drawer as DrawerAnt, DrawerProps } from 'antd'
import './drawer.scss'

const Drawer: FC<DrawerProps> = (props) => (
	<DrawerAnt className="ui-drawer-wrapper" {...props} />
)

export default Drawer
